var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.72,
    height: 12.72,
    viewBox: "0 0 12.72 12.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56846",
    "data-name": "Group 56846",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56847",
    "data-name": "Group 56847",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56844",
    "data-name": "Group 56844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56848",
    "data-name": "Group 56848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56842",
    "data-name": "Group 56842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56849",
    "data-name": "Group 56849"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9716",
    "data-name": "Path 9716",
    d: "M4.4,12.72H4.074c-.074-.023-.148-.046-.222-.07-1.033-.344-2.067-.685-3.1-1.033a1.051,1.051,0,0,1-.73-.8A.369.369,0,0,0,0,10.757V.894C.01.864.022.835.031.8A1.064,1.064,0,0,1,.722.056C.778.035.837.019.894,0H7.08c.031.009.062.02.094.025A1.575,1.575,0,0,1,8.467,1.44c.022.591.008,1.184.007,1.776a.469.469,0,0,1-.192.374.5.5,0,0,1-.548.071.49.49,0,0,1-.31-.469c0-.509,0-1.019,0-1.528a.538.538,0,0,0-.595-.6H4.616c-.036,0-.071,0-.111.005.009.013.011.022.017.024A1.078,1.078,0,0,1,5.3,2.265q0,3.82,0,7.639v.164h1.51a.544.544,0,0,0,.614-.621q0-.981,0-1.963a.819.819,0,0,1,.02-.209A.525.525,0,0,1,8,6.892a.515.515,0,0,1,.478.513q.008,1.062,0,2.124a1.582,1.582,0,0,1-1.612,1.6c-.476,0-.952,0-1.428,0H5.3c0,.2.005.391,0,.576a.962.962,0,0,1-.419.793,2.924,2.924,0,0,1-.478.221",
    fill: "#6f109e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9718",
    "data-name": "Path 9718",
    d: "M283.218,109.407a3.439,3.439,0,0,1-.292.391c-.645.655-1.3,1.3-1.947,1.952a.545.545,0,0,1-.5.181.526.526,0,0,1-.438-.539c0-.472,0-.944,0-1.416v-.154h-.15c-.642,0-1.283,0-1.925,0a.534.534,0,0,1-.562-.426.525.525,0,0,1,.534-.635c.65,0,1.3,0,1.95,0h.153v-.137c0-.468,0-.936,0-1.4a.535.535,0,0,1,.938-.393c.687.689,1.377,1.374,2.061,2.067a1.556,1.556,0,0,1,.182.289Z",
    transform: "translate(-270.498 -103.991)",
    fill: "#6f109e"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1e0ffb2e2fe2635995784a4c39fabfa0.svg";
export { ForwardRef as ReactComponent };